var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const formatComponentName = (vm) => {
  if (!vm) {
    return "vm not found";
  }
  if (vm.$root === vm) {
    return "root instance";
  }
  const name = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name;
  return (name ? `component <${name}>` : "anonymous component") + (vm._isVue && vm.$options.__file ? ` at ${vm.$options.__file}` : "");
};
const buildVueError = (error, vm, info, { tier } = {}) => {
  var _a;
  return __spreadProps(__spreadValues(__spreadValues({}, error && {
    Exception: error.name,
    ExceptionMessage: error.message,
    ExceptionStackTrace: error.stack
  }), tier && {
    Tier: tier
  }), {
    "vue.componentName": formatComponentName(vm),
    "vue.propsData": (_a = vm == null ? void 0 : vm.$options) == null ? void 0 : _a.propsData,
    "vue.lifecycleHook": info
  });
};
var loggerService = {
  buildVueError
};
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const __vue2_script = {
  props: {
    tier: {
      type: String,
      default: null
    },
    stopPropagation: {
      type: Boolean,
      default: true
    },
    hideOnError: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    hasError: false,
    error: null,
    vm: null,
    info: null
  }),
  computed: {
    loggerPayload() {
      return loggerService.buildVueError(this.error, this.vm, this.info, {
        tier: this.tier
      });
    }
  },
  errorCaptured(error, vm, info) {
    return this.interceptError(error, vm, info);
  },
  methods: {
    interceptError(error, vm, info) {
      this.hasError = true;
      this.error = error;
      this.vm = vm;
      this.info = info;
      this.$emit("on-error", {
        error,
        vm,
        info,
        tier: this.tier,
        loggerPayload: this.loggerPayload
      });
      return !this.stopPropagation;
    }
  },
  render() {
    var _a, _b;
    return this.hideOnError && this.hasError ? null : (_b = (_a = this.$scopedSlots).default) == null ? void 0 : _b.call(_a, {
      hasError: this.hasError,
      error: this.error,
      vm: this.vm,
      info: this.info,
      tier: this.tier,
      loggerPayload: this.loggerPayload
    });
  }
};
let __vue2_render, __vue2_staticRenderFns;
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, __vue2_render, __vue2_staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var ErrorBoundary = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export { ErrorBoundary as default };
//# sourceMappingURL=f-error-boundary.es.js.map
